module.exports = __webpack_public_path__ + "static/media/parin.3dbf6583.png";